module.exports = __webpack_public_path__ + "img/finance.bab5fff8.svg";